import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    background: white;
    height: 53.5px;
    width: 100%;    
    padding-left: 15px;    
`